
import { defineComponent } from "vue";
import CustomConfirmDialog from "@/components/primevueCustom/ConfirmDialog.vue";
import { useConfirm } from "primevue/useconfirm";
import { ICancelRequestParam } from "@/models/request";
import $API from "@/services";
import { useI18n } from "vue-i18n";

export default defineComponent({
  props: {
    accept: { type: Function, default: () => {}, required: false },
    reject: { type: Function, default: () => {}, required: false },
  },
  setup(props) {
    const requestcancelConfirm = useConfirm();
    const { t } = useI18n({ useScope: "global" });

    const cancelConfirm = (requestKey: number) => {
      requestcancelConfirm.require({
        header: "예약취소",
        message: "해당 예약을 취소하시겠습니까? 취소 후 복구가 불가능합니다.",
        acceptClass: "p-button-danger",
        acceptLabel: t("Yes"),
        rejectLabel: t("No"),
        group: "cancel",
        accept: async () => {
          const cancelRequestParam: ICancelRequestParam = {
            RequestKey: requestKey,
          };
          const canceled = await $API.RequestService.cancelRequest(
            cancelRequestParam
          );
          if (canceled) {
            if (props.accept) props.accept();
          }
        },
        reject: () => {
          if (props.reject) props.reject();
        },
      });
    };
    return {
      cancelConfirm,
    };
  },
  components: {
    CustomConfirmDialog,
  },
});
